import React from "react";
import {
  BrowserRouter,
  Route,
  Switch,
} from 'react-router-dom';


import Login from "./pages/Login/Login";
import Dashboard from "./pages/Dashboard/Dashboard";

import Notfound from "./pages/Notfound";

import { PrivateRoute } from "./PrivateRoute";

export default function Routes() {
  return (
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Switch>
        <Route path="/" exact component={Login} />
        <PrivateRoute path="/" component={Dashboard} />
        <Route component={Notfound} />
      </Switch>
    </BrowserRouter >
  )
}